import { Typography, styled } from "@mui/material"

import { L2RTextField as UiTextField } from "../TextField"

type StyledTextFieldProps = {
    hasSeparator?: boolean,
}

export const TextField = styled(UiTextField, { shouldForwardProp: (prop) => prop !== "hasSeparator" })<StyledTextFieldProps>(({ hasSeparator = false, theme }) => ({

    "& .MuiInputBase-root": {
        width: "100%",
    },

    "& .MuiInputBase-input": {
        overflow: "hidden",
        textOverflow: "ellipsis",
        borderRight: hasSeparator ? `2px solid ${theme.palette["_components/input/enabledBorder"].main}` : 0,
        paddingRight: theme.spacing(1),
    },
}))

export const ExtensionAdornment = styled(Typography)(({ theme }) => ({
    color: theme.palette["text/disabled"].main,
    textTransform: "uppercase",
    paddingLeft: 10,
    minWidth: 42,
}))